import { Spinner } from '@vwfs-bronson/bronson-react'
import React from 'react'

export default function SpinnerElement({ visible }) {
  if (visible) {
    return <Spinner className="u-m-xlarge" center fullPage></Spinner>
  }
  return null
}
